import { useState } from "react";

interface AccordionProps {
  items: { q: string; a: string }[];
}

export default function Accordion({ items }: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, idx) => {
        const open = openIndex === idx;
        return (
          <div
            key={idx}
            className="overflow-hidden rounded-lg border border-background-200 bg-white"
          >
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : idx)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
            >
              <span className="text-sm font-semibold text-foreground-900 md:text-base">
                {item.q}
              </span>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                <i className={`text-base ${open ? "ri-subtract-line" : "ri-add-line"}`}></i>
              </span>
            </button>
            {open && (
              <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                {item.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}